import Vue from 'vue'
import axios from 'axios'

const API_URL = '/api/1'

function parseJwt(jwt) {
    let payloadBase64 = jwt.split(".")[1]
    if (payloadBase64 === undefined) {
        return null
    }
    payloadBase64 = payloadBase64.replace("-", "+").replace("_", "/")

    const payload = window.atob(payloadBase64)
    return JSON.parse(payload)
}

let instance

export const Api = () => {
    if (instance) return instance

    instance = new Vue({
        data() {
            return {
                token: null
            }
        },
        created() {
            let token = localStorage.getItem("jwt")

            const tokenMatch = window.location.hash.match(/^#token=(.*)/)
            if (tokenMatch !== null) {
                token = tokenMatch[1]
                localStorage.setItem("jwt", token)
                window.history.pushState(null, "", "/")
            }
            let payload = parseJwt(token)
            const now = Math.floor(Date.now() / 1000);
            if (payload) {
                if (payload.exp <= now) {
                    localStorage.removeItem("jwt")
                } else {
                    this.token = token
                }
            }
        },
        computed: {
            isAuthenticated() {
                return this.token !== null
            }
        },
        methods: {
            login() {
                window.location.href = `${API_URL}/authenticate`
            },
            logout() {
                localStorage.removeItem("jwt")
                window.location.href = `${API_URL}/logout`
            },
            async request(method, url, data) {
                const headers = this.token ? {Authorization: `Bearer ${this.token}`} : {}
                try {
                    const response = await axios.request({ method, url, data, headers })
                    return response.data
                } catch(error) {
                    if (error.response.status === 403) {
                        await this.login()
                    }
                    throw error
                }
            },
            async get(url) {
                return await this.request('GET', url)
            },
            async post(url, data) {
                return await this.request('POST', url, data)
            },
            async delete(url) {
              return await this.request('DELETE', url)
            },
            async getItem(articleId) {
                return await this.get(API_URL + '/item/' + articleId)
            },
            async getNotification(articleId) {
                return await this.get(API_URL + '/notifications?article_id=' + articleId)
            },
            async getNotifications(limit = 10, offset=0, channel = '') {
                let url = API_URL + '/notifications?limit=' + limit + '&offset=' + offset
                if (channel.length > 0 && channel !== 'all') {
                    url = url + '&channel=' + channel
                }
                return await this.get(url)
            },
            async getScheduledNotifications() {
                return await this.get(`${API_URL}/notifications/scheduled`)
            },
            async deleteScheduledNotification(id) {
                return await this.delete(`${API_URL}/notifications/scheduled/cancel?notification_id=${id}`)
            },
            async sendNotification(data) {
                return await this.post(API_URL + '/notifications', data)
            }
        }
    })

    return instance
}

export const ApiPlugin = {
    install(Vue) {
        Vue.prototype.$api = Api()
    }
}
